class expansionSFA {
	PATH = location.pathname.split('/').filter(Boolean);
	constructor() {
		const checking = () => {
			const flg = setTimeout(checking, 100);
			if (window.AppFavoriteButton === undefined || window.AppFavoriteButton.cookie === undefined) {
				return;
			}

			clearTimeout(flg);

			Object.assign(this, window.AppFavoriteButton);

			if (this.settings.setting !== 'on') {
				return;
			}

			const show = this.settings.show;

			// top page
			if (this.PATH.length === 0 && show.top == 0) {
				this.top();
			}

			// collections
			if ((this.PATH.includes('collections') && !this.PATH.includes('products')) && show.collection == 0) {
				this.collection();
			}

			// products
			if (this.PATH.includes('products') && show.product === 0) {
				this.products();
			}
		};
		checking();
	}

	top() {
	}

	collection() {
		const target = document.querySelector('#ProductGridContainer');
		const param = { subtree: true, childList: true };
		const setButton = () => {
			window.AppFavoriteButton.insertButtonCollectionList({
				list: [...target.querySelectorAll('.grid__item .card__information a')]
			});
		};
		setButton();
		
		const observer = new MutationObserver(() => {
			observer.disconnect();
			
			setButton();

			observer.observe(target, param);
		});
		observer.observe(target, param);
	}

	products() {
	}
};
new expansionSFA;